import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { RoutePath } from "@/section/router";

const tabs = [
  {
    label: "Reports",
    path: RoutePath.CfrDocumentsReports,
  },
  {
    label: "Templates",
    path: RoutePath.CfrDocumentsTemplates,
  },
  {
    label: "Instances",
    path: RoutePath.CfrDocumentsInstances,
  },
];

export function CfrDocumentsDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === RoutePath.CfrDocuments) {
      navigate(RoutePath.CfrDocumentsInstances, { replace: true });
    }
  }, [location.pathname, navigate]);

  const isActiveTab = (path: string) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="flex h-full flex-col gap-4 overflow-hidden max-h-[95vh]">
      <div className="flex flex-wrap gap-2">
        {tabs.map((tab, index) => (
          <div key={tab.path} className="flex items-center">
            <Button
              variant="ghost"
              className={cn(
                "text-xl font-bold p-0 h-auto hover:bg-transparent",
                isActiveTab(tab.path)
                  ? "text-foreground"
                  : "text-muted-foreground hover:text-foreground",
              )}
              onClick={() => navigate(tab.path)}
            >
              {tab.label}
            </Button>
            {index < tabs.length - 1 && (
              <span className="mx-2 text-xl font-bold text-muted-foreground">
                /
              </span>
            )}
          </div>
        ))}
      </div>

      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
